/* eslint-disable max-statements */
/* eslint-disable max-statements, complexity */
import React, { useEffect, useRef, useState } from "react";
import styles from "./styles.css";
import { useStepper } from "../../../hooks/use-stepper.desktop";
import ErrorHandler from "../../shared/with-error-handler";
import { STEP_CONFIG } from "./step-mapper";
import PropTypes from "prop-types";
import CarEvaluationStep from "../car-evaluation-step";
import querystring from "querystring";
import { OFFER_PRICE_ROUTE, APPOINTMENT_BOOKING_ROUTE } from "../../../constants/app-constants";
import PageLoader from "../../shared/page-loader";
import { ALL_MKT_LEAD_TYPES } from "../../../constants/seller-lead-types";
import { SELL_ONLINE_STEP_KEY, SELL_ONLINE_TAB_LIST } from "../../../constants/sell-online-constant";

const SELL_ONLINE_QUESTION = ["/sell-online-questions"];
const dwebWebquotePage = "dweb-web-quote-page";
const SELLER_PROCESS_STEPPER = "SELLER_PROCESS_STEPPER";

const SellOnlineLeadStepContainer = ({
    faqs = [],
    stepsConfig = STEP_CONFIG,
    sellOnlineLeadData,
    setDataConnect,
    setStepConnect,
    history,
    setMobileConnect,
    setOfferPriceConnect,
    mergeLeadDataConnect,
    updateLeadTypeConnect,
    fetchLeadDetailsConnect,
    isSubmittingDataConnect,
    setLeadMobileConnect,
    resetLeadFormDataConnect,
    resetSellOnlineLeadDataConnect,
    submitAppointmentFailureConnect,
    mergeNonSoLeadDataConnect,
    setFetchLeadDetailConnect,
    isFetching,
    manualCurrentStep,
    errorHandler = () => {},
    secureToken,
    details,
    getCmsPageTemplateDataConnect,
    isConfirmationPage
}) => {
    const { currentStep: reduxCurrentStep } = sellOnlineLeadData;
    const currentStep = manualCurrentStep || reduxCurrentStep;
    const sliderRef = useRef();
    const BOOKING_FORM_SLIDES_TO_SHOW = 3;
    const settings = {
        slidesToShow: BOOKING_FORM_SLIDES_TO_SHOW,
        slidesToScroll: 1,
        infinite: false,
        arrow: true,
        focusOnSelect: true,
        ref: sliderRef,
        rows: 2
    };
    const config = stepsConfig;
    const [formConfig] = useState(config);
    const { stepper, tabs = SELL_ONLINE_TAB_LIST  } = formConfig;
    const [isCurrentStepUpdated, setIsCurrentStepUpdated] = useState(false);
    const [stepperData, setStepperData] = useState({});
    const [step, prev, next, renderStep] = useStepper(currentStep, stepper);

    useEffect(() => {
        renderStep();
    }, [renderStep]);

    const getSellStep = () => {
        if (OFFER_PRICE_ROUTE.includes(history.location.pathname)) {
            setStepConnect({
                currentStep: SELL_ONLINE_STEP_KEY.FINAL_OFFER
            });
        }
        if (APPOINTMENT_BOOKING_ROUTE.includes(history.location.pathname)) {
            setStepConnect({
                currentStep: SELL_ONLINE_STEP_KEY.APPOINTMENT_DETAILS
            });
        }
    };
    useEffect(() => {
        const recieveParams = () => {
            const { location: { search } } = history;
            return search && querystring.parse(search.replace(/\?/g, ""));
        };

        const queryParams = recieveParams();

        if (history.location.pathname === "/sell-online-evaluation") {
            setStepConnect({
                currentStep: SELL_ONLINE_STEP_KEY.BASIC_DETAILS,
                tabs
            });
        }
        if (["/sell-online-questions", "/sell-online-questions/"].includes(history.location.pathname)) {
            setStepConnect({
                currentStep: SELL_ONLINE_STEP_KEY.CAR_CONDITION,
                tabs
            });
        }
        if (["/appointment/confirmation", "/appointment/confirmation/"].includes(history.location.pathname)) {

            if (queryParams && queryParams.l && queryParams.e) {
                setStepConnect({
                    currentStep: SELL_ONLINE_STEP_KEY.BOOK_INSPECTION,
                    tabs
                });
            } else {
                setStepConnect({
                    currentStep: SELL_ONLINE_STEP_KEY.INSPECTION_BOOKED,
                    tabs
                });
            }

        }

        if (["/appointment/index", "/appointment/index/"].includes(history.location.pathname)) {
            setStepConnect({
                currentStep: SELL_ONLINE_STEP_KEY.PRICE_ESTIMATE,
                tabs
            });
        }
        getSellStep();
        setIsCurrentStepUpdated(true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const checkIsLeadClear = (source) => {
        if (source && ALL_MKT_LEAD_TYPES.includes(source)) {
            history.push("/sell-marketing");
        } else {
            history.push("/sell-used-cars");
            setStepConnect({
                currentStep: SELL_ONLINE_STEP_KEY.BASIC_DETAILS
            });
        }
    };
    useEffect(() => {
        /*
        * getting token from query params
        */
        const { location: { search } } = history;
        const query = search && querystring.parse(search.replace(/\?/g, ""));
        setFetchLeadDetailConnect(null);
        if (query.token) {
            fetchLeadDetailsConnect(query.token, secureToken)
                .then((response) => {
                    if (response.offered_price && response.gs_eligible_car === "yes") {
                        if (SELL_ONLINE_QUESTION.includes(history.location.pathname)) {
                            checkIsLeadClear(response.lead_type);
                        }
                        resetSellOnlineLeadDataConnect({...response});
                        getSellStep();
                        resetLeadFormDataConnect();
                        setLeadMobileConnect("");
                        submitAppointmentFailureConnect();
                    } else {
                        mergeLeadDataConnect({ ...response, token: query.token });
                        mergeNonSoLeadDataConnect({ ...response, token: query.token });
                    }
                    setMobileConnect(response.phone);
                    updateLeadTypeConnect(response.lead_type);
                    setOfferPriceConnect(response.offered_price);
                    isSubmittingDataConnect(false);
                    setFetchLeadDetailConnect(true);
                }).catch(() => {
                    setFetchLeadDetailConnect(true);
                });
        }
        /*
        * fetching lead detail with that token
        */
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [history]);

    const getSectionByName = (name, pageSections = []) =>
        pageSections.length > 0 && pageSections.find(item => item.pageSection?.name === name)?.pageSection;

    useEffect(() => {
        const getCMSData = () => {
            getCmsPageTemplateDataConnect(dwebWebquotePage).then((response) => {
                if (response.data.data) {
                    const pageSections = response?.data?.data?.pageSections || [];
                    const stepperValues = getSectionByName(SELLER_PROCESS_STEPPER, pageSections);
                    setStepperData(stepperValues);
                }
            }).catch(() => {
                setStepperData([]);
            });
        };
        getCMSData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (!isCurrentStepUpdated) return <PageLoader />;

    return (
        <React.Fragment>
            <div styleName={"styles.wrapper"}>
                <div styleName={"styles.leftColumn"}>
                    <CarEvaluationStep
                        referenceStore={sellOnlineLeadData}
                        appointmentDetails={details}
                        stepperData={stepperData}
                        isConfirmationPage={isConfirmationPage}
                    />
                </div>
                <div styleName={"styles.rightColumn"}>
                    {step && isCurrentStepUpdated &&
                    <ErrorHandler>
                        <step.component
                            faqs={faqs}
                            currentStep={currentStep}
                            nextStepName={next}
                            sliderSetting={settings}
                            sellOnline={true}
                            referenceStore={sellOnlineLeadData}
                            isFetching={isFetching}
                            setData={(type, data) => setDataConnect(type, data, tabs)}
                            nextStep={() =>
                                setStepConnect({
                                    currentStep: next,
                                    tabs
                                })
                            }
                            nextStepManually={(stepName) =>
                                setStepConnect({
                                    currentStep: stepName,
                                    tabs
                                })
                            }
                            prevStep={() => {
                                setStepConnect({
                                    currentStep: prev,
                                    tabs
                                });
                            }}
                            validateKms={true}
                            errorHandler={errorHandler}
                        />
                    </ErrorHandler>
                    }
                </div>
            </div>
        </React.Fragment>
    );
};

SellOnlineLeadStepContainer.propTypes = {
    details: PropTypes.any,
    faqs: PropTypes.array,
    reschedule: PropTypes.object,
    sellOnlineLeadData: PropTypes.object,
    setDataConnect: PropTypes.func,
    setStepConnect: PropTypes.func,
    history: PropTypes.object,
    appointmentDetails: PropTypes.any,
    setMobileConnect: PropTypes.func,
    setOfferPriceConnect: PropTypes.func,
    mergeLeadDataConnect: PropTypes.func,
    updateLeadTypeConnect: PropTypes.func,
    fetchLeadDetailsConnect: PropTypes.func,
    isSubmittingDataConnect: PropTypes.any,
    setLeadMobileConnect: PropTypes.any,
    resetSellOnlineLeadDataConnect: PropTypes.func,
    resetLeadFormDataConnect: PropTypes.func,
    submitAppointmentFailureConnect: PropTypes.func,
    mergeNonSoLeadDataConnect: PropTypes.func,
    setFetchLeadDetailConnect: PropTypes.func,
    isFetching: PropTypes.bool,
    stepsConfig: PropTypes.array,
    manualCurrentStep: PropTypes.string,
    errorHandler: PropTypes.func,
    secureToken: PropTypes.string,
    getCmsPageTemplateDataConnect: PropTypes.func,
    isConfirmationPage: PropTypes.bool
};

export default SellOnlineLeadStepContainer;

